import { connect } from "react-redux"
import Drawer from "./Drawer"
import { setDrawerIsOpen } from "store/actions/reduxActions"
import { signOut } from "store/actions/auth"

const mapStateToProps = (state, props) => ({
	isOpen: state.drawerIsOpen,
	isOffline: state.isOffline,
	userPrivileges: (state.user || {}).privileges,
})

const mapDispatchToProps = (dispatch) => ({
	setIsOpen: (isOpen) => dispatch(setDrawerIsOpen(isOpen)),
	signOut: () => dispatch(signOut()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Drawer)
